const FILE_SIZE_UNITS = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
const FILE_SIZE_UNITS_LONG = [
  '',
  'Kilo',
  'Mega',
  'Giga',
  'Petta',
  'Exa',
  'Zetta',
  'Yotta',
];

export function formatFileSize(
  sizeInBytes: number,
  unit: 'B' | 'b' | 'Bytes' | 'bites' = 'b',
  postfix = '',
): string {
  const base = unit === 'B' || unit == 'Bytes' ? 1024 : 1000;
  const longForm = unit === 'Bytes' || unit === 'bites';
  const units = longForm ? FILE_SIZE_UNITS_LONG : FILE_SIZE_UNITS;

  let power = Math.round(Math.log(sizeInBytes) / Math.log(base));
  power = Math.min(power, units.length - 1);

  const size = sizeInBytes / Math.pow(base, power);
  const formattedSize = Math.round(size * 100) / 100;
  const unitPrefix = units[power];

  return `${formattedSize} ${unitPrefix}${unit}${postfix}`;
}

export function formatSpeed(value?: number): string {
  if (!value) {
    return '';
  }
  return formatFileSize(value, 'b', 'ps');
}
